import styled from 'styled-components'

import { IconComponentStyled } from '@ui/elements/Icon'

interface IBulletedListItemStyledProps {
  showBullet: boolean
}

export const BulletedListItemStyled = styled.li<IBulletedListItemStyledProps>`
  font-size: ${(props) =>
    props.theme.typography.pxToRem(props.theme.fontSizes.body1)};

  ${(props) =>
    !props.showBullet &&
    `
  list-style-type: none;
  margin-left: -${props.theme.space.medium};
  `}

  ${IconComponentStyled} {
    vertical-align: middle;
  }
`
